export enum COLORS {
    info = 'info',
    dark = 'dark',
    light = 'light',
    danger = 'danger',
    primary = 'primary',
    success = 'success',
    warning = 'warning',
    secondary = 'secondary',
}

export const DEFAULT_CONFIG = {
    radius: false,
    type: COLORS.light,
};
